const mediaQuery = {
  mobile: "480px",
  tablet: "768px",
  laptop: "922px",
  desktop: "1200px",
  big: "1600px",
};

export default mediaQuery;
